import { Base } from './Base';
import { initBehaviors, destroyBehaviors } from '..';
import events from '../../constants/events';
import { dispatchEvent } from '../../utilities/customEvents'
import { relewiseRecommend } from '../../utilities/relewise';

export class PopularProducts extends Base {
    constructor(behaviorName, element) {
        super(behaviorName, element);
        this.minutesAgo = this.element.dataset.daysAgo * 1440;
        this.vendor = this.element.dataset.vendor;
        this.recommendationType = this.element.dataset.recommendationType;
        this.init();
    }

    init() {
        const body = document.body;
        const { products } = this.refs;
        body.style.setProperty(
          "--popular-products-product-background-color",
          products.getAttribute("data-product-background-color")
        );

        body.style.setProperty(
          "--popular-products-text-color",
          products.getAttribute("data-text-color")
        );

        try {
            this.cacheLoadingMarkup();
            this.bindFunctions();
            this.setEventListeners();
            this.onReady();
        } catch (error) {
            console.log(error);
        }


    }

    bindFunctions() {
        this.onReady = this.onReady.bind(this);
        this.variantChanged = this.variantChanged.bind(this);
    }

    setEventListeners() {
        window.addEventListener(events.PRODUCT_DATA_LOADED, this.onReady);
        window.addEventListener(events.VARIANT_CHANGED, this.variantChanged);
    }

    cacheLoadingMarkup() {
        const { carouselWrapper } = this.refs;
        this.loadingMarkup = carouselWrapper.innerHTML;
    }

    variantChanged(e) {
        this.currentVariantId = e.detail.variant.sku;
        this.displayLoadingMarkup();
        this.onReady();
    }

    displayLoadingMarkup() {
        const { carouselWrapper } = this.refs;
        carouselWrapper.innerHTML = this.loadingMarkup;
    }


    onReady() {

        try {
            if (Cookiebot) {
                relewiseRecommend(
                  this.recommendationType === "Personal"
                    ? "PopularProductsPersonal"
                    : "PopularProducts",
                  {
                    minutesAgo: this.minutesAgo,
                    vendor: this.vendor,
                    basedOn: this.recommendationType,
                  }
                )
                  .then((response) => response.json())
                  .then((json) => {
                    if (json) {
                      this.compileProductCards(json);
                    }
                  })
                  .catch((error) => {
                    console.log(error);
                    this.handleErrors();
                  });
            }

        } catch (error) {
            console.log(error);
        }

    }

    applyDataModelling(data) {
        const modeledData = [];

        data.forEach(entry => {
            modeledData.push({
                crossStoreProductId: parseInt(entry.productId),
                variantId: parseInt(entry.variant.variantId)
            })
        });

        return modeledData;
    }

    async compileProductCards(json) {
      const {
        productCardTemplate,
        productCardMediaItemTemplate,
        swatchTemplate,
        swatchItemTemplate,
        carousel,
        carouselWrapper
      } = this.refs;

      const templates = {
        productCardTemplate,
        productCardMediaItemTemplate,
        swatchTemplate,
        swatchItemTemplate,
      }

      if (json.recommendations.length) {
        const productHandles = [...json.recommendations
          .filter(entry => entry.productId && entry.variant && entry.variant.data[`${window.mosmosh.shop_code.toUpperCase()}_ShopifyHandle`])
          .map(entry => {
            return entry.variant.data[`${window.mosmosh.shop_code.toUpperCase()}_ShopifyHandle`].value
          })]

        const productFetches = productHandles.map((handle) => {
          const url = new URL(`${window.location.origin}/products/${handle}`);
          url.searchParams.set('view', 'item');

          return fetch(url.toString())
        });

        const productItems = await Promise.all((await Promise.all(productFetches)).map((fetch) => {
          if (fetch.status === 200) {
            return fetch.text()
          }
        }));

        if (productItems.length) {
          carouselWrapper.innerHTML = '';
          carouselWrapper.insertAdjacentHTML('beforeend', productItems.filter(item => item).map((html => `<div class="swiper-slide swiper-product-slide carousel__item carousel__item--4-of-8 carousel__item--2-of-8-md">${html}</div>`)).join(''))
        }

        dispatchEvent(window, events.PRODUCT_IMAGES_UPDATED);
      }

      //Destory before init, to re-init carousel
      destroyBehaviors(carousel);
      initBehaviors(carousel);
    }

    handleErrors() {
        this.element.remove();
    }

    cleanup() {
        window.removeEventListener(events.VARIANT_CHANGED, this.variantChanged);
    }
}

